var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bag",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_twotone_bag",
    "data-name": "vuesax/twotone/bag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bag-2",
    "data-name": "bag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.127,0H17.039c1.179,0,2.127.144,2.127,1.917,0,2.06-.949,1.917-2.127,1.917H2.127C.949,3.833,0,3.977,0,1.917,0,.144.949,0,2.127,0Z",
    transform: "translate(0.917 2.761)",
    fill: "none",
    stroke: "#f85466",
    strokeWidth: 1,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    transform: "translate(4.541 -0.261)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M3.168,3.176",
    transform: "translate(8.75)",
    fill: "none",
    stroke: "#f85466",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0V3.106",
    transform: "translate(3.999 10.5)",
    fill: "none",
    stroke: "#f85466",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0V3.106",
    transform: "translate(8.024 10.5)",
    fill: "none",
    stroke: "#f85466",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "0 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0,1.351,8.28C1.658,10.139,2.4,11.5,5.137,11.5h5.779c2.98,0,3.421-1.3,3.766-3.1L16.292,0",
    transform: "translate(2.354 6.739)",
    fill: "none",
    stroke: "#f85466",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M21,0V21H0V0Z",
    fill: "none",
    stroke: "#f85466",
    strokeWidth: 1,
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.bc12c523c113b070364804f4b2fddd42.svg";
export { ForwardRef as ReactComponent };